import { useQueries } from '@tanstack/react-query';
// utils
import { personasAPI } from '@/services/customer/personas/personas.queries.ts';

export const usePersonaDetailsQuery = (personaId: string) => {
    return useQueries({
        queries: [
            {
                queryKey: ['persona/actors', personaId],
                queryFn: async () => personasAPI.getPersonaActors(personaId)
            },
            {
                queryKey: ['persona/attributes', personaId],
                queryFn: async () => personasAPI.getPersonaAttributes(personaId)
            }
        ],
        combine: ([actorsResult, attributesResult]) => {
            return {
                actors: actorsResult.data ?? [],
                attributes: attributesResult.data ?? [],
                isLoading: actorsResult.isLoading || attributesResult.isLoading,
                isSuccess: actorsResult.isSuccess && attributesResult.isSuccess
            };
        }
    });
};
